interface WorkerStatusCardProps {
  running: boolean
  lastScan: string | null
  successfulMerges: number
  failedAttempts: number
  onClick: () => void
}

function formatTimeShort(dateStr: string | null): string {
  if (!dateStr) return '—'
  const d = new Date(dateStr)
  const h = String(d.getHours()).padStart(2, '0')
  const m = String(d.getMinutes()).padStart(2, '0')
  const s = String(d.getSeconds()).padStart(2, '0')
  return `${h}:${m}:${s}`
}

export function WorkerStatusCard({ running, lastScan, successfulMerges, failedAttempts, onClick }: WorkerStatusCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="animate-fade-in-up"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '24px',
        padding: '12px 20px',
        background: 'var(--bg-card)',
        border: `1px solid ${running ? 'var(--green)' : 'var(--border-default)'}`,
        cursor: 'pointer',
        width: '100%',
        textAlign: 'left',
        transition: 'border-color 0.15s ease, background 0.15s ease',
      }}
      onMouseEnter={(e) => {
        ;(e.currentTarget as HTMLButtonElement).style.background = 'var(--bg-hover)'
      }}
      onMouseLeave={(e) => {
        ;(e.currentTarget as HTMLButtonElement).style.background = 'var(--bg-card)'
      }}
    >
      {/* Status badge */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span
          className={`live-dot ${running ? 'animate-pulse-dot' : ''}`}
          style={{ color: running ? 'var(--green)' : 'var(--text-muted)', fontSize: '8px' }}
        >
          ●
        </span>
        <span
          className="font-mono"
          style={{
            fontSize: '10px',
            fontWeight: 600,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: running ? 'var(--green)' : 'var(--text-muted)',
          }}
        >
          Worker {running ? 'Running' : 'Stopped'}
        </span>
      </div>

      <div style={{ width: '1px', height: '20px', background: 'var(--border-subtle)' }} />

      {/* Stats */}
      <div style={{ display: 'flex', gap: '24px', flex: 1 }}>
        <div>
          <div className="font-mono" style={{ fontSize: '8px', letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--text-muted)', marginBottom: '2px' }}>
            Last Scan
          </div>
          <div className="font-mono" style={{ fontSize: '12px', color: 'var(--text-primary)', fontVariantNumeric: 'tabular-nums' }}>
            {formatTimeShort(lastScan)}
          </div>
        </div>

        <div>
          <div className="font-mono" style={{ fontSize: '8px', letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--text-muted)', marginBottom: '2px' }}>
            Successful Merges
          </div>
          <div className="font-mono" style={{ fontSize: '12px', color: 'var(--text-primary)', fontVariantNumeric: 'tabular-nums' }}>
            {successfulMerges}
          </div>
        </div>

        <div>
          <div className="font-mono" style={{ fontSize: '8px', letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--text-muted)', marginBottom: '2px' }}>
            Failed Attempts
          </div>
          <div className="font-mono" style={{ fontSize: '12px', color: 'var(--text-primary)', fontVariantNumeric: 'tabular-nums' }}>
            {failedAttempts}
          </div>
        </div>
      </div>

      {/* Click hint */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <span className="font-mono" style={{ fontSize: '9px', letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--text-muted)' }}>
          Open Controls
        </span>
        <span style={{ color: 'var(--text-muted)', fontSize: '10px' }}>›</span>
      </div>
    </button>
  )
}
